if (!customElements.get('lila-bundle')) {
  customElements.define('lila-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dataset.root = (this.dataset.root || '/').replace(/\/?$/, '/');
      this.copy = JSON.parse(this.querySelector("[data-bundle-i18n]").textContent);
      this.rows = [...this.querySelectorAll('.lb-product')];
      this.quantities = new Map(this.rows.map(r => [r.dataset.id, 0]));
      this.submit = this.querySelector('.lb-submit');
      this.status = this.querySelector('.lb-status');
      this.busy = false;
      this.locked = false;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'de', {style:'currency',currency:this.dataset.currency || 'EUR'});
      this.addEventListener('change', e => { if(e.target.matches('input[type=radio]')) this.render(); });
      this.addEventListener('click', e => {
        const button = e.target.closest('[data-change]');
        if (!button || this.busy || this.locked) return;
        const row = button.closest('.lb-product');
        const id = row.dataset.id;
        const next = this.quantities.get(id) + Number(button.dataset.change);
        if(next < 0 || next > Number(row.dataset.max)) return;
        if(Number(button.dataset.change) > 0 && this.count() >= this.tier().count) return;
        this.quantities.set(id,next);
        this.render();
      });
      this.submit.addEventListener('click', () => this.addBundle());
      this.render();
    }
    text(key, values={}) { return Object.entries(values).reduce((s,[k,v])=>s.replaceAll("%"+k+"%",String(v)),this.copy[key]); }
    tier(){const r=this.querySelector('input[type=radio]:checked');return {count:Number(r.value),rate:Number(r.dataset.rate),code:r.dataset.code};}
    count(){return [...this.quantities.values()].reduce((a,b)=>a+b,0);}
    render(){
      const tier=this.tier(), count=this.count();
      let subtotal=0,saving=0;
      const list=this.querySelector('.lb-selection');list.replaceChildren();
      this.rows.forEach(row=>{
        const q=this.quantities.get(row.dataset.id), price=Number(row.dataset.price);
        row.querySelector('output').textContent=q;
        row.querySelector('[data-change="-1"]').disabled=this.busy||this.locked||q===0;
        const plus=row.querySelector('[data-change="1"]');
        plus.disabled=this.busy||this.locked||plus.dataset.unavailable==='true'||q>=Number(row.dataset.max)||count>=tier.count;
        if(q){subtotal+=price*q;saving+=Math.floor(price*tier.rate/100)*q;const li=document.createElement('li');li.textContent=q+' × '+row.dataset.title;list.append(li);}
      });
      this.querySelector('.lb-empty').hidden=count>0;
      this.querySelector('.lb-progress').textContent=this.text('selected',{count,total:tier.count})+(count>tier.count?this.text('remove',{count:count-tier.count}):'');
      this.querySelector('.lb-track span').style.width=Math.min(100,count/tier.count*100)+'%';
      this.querySelector('[data-subtotal]').textContent=this.money.format(subtotal/100);
      this.querySelector('[data-saving]').textContent='− '+this.money.format(saving/100);
      this.querySelector('[data-total]').textContent=this.money.format((subtotal-saving)/100);
      this.querySelector('[data-rate-label]').textContent='('+tier.rate+'%)';
      this.submit.disabled=this.busy||this.locked||count!==tier.count||!tier.code;
      this.querySelectorAll('input[type=radio]').forEach(r=>r.disabled=this.busy||this.locked);
    }
    async addBundle(){
      if(this.busy||this.locked||this.count()!==this.tier().count) return;
      const tier=this.tier();
      this.busy=true;this.status.textContent=this.text('adding');this.render();
      const group=Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8);
      const items=[...this.quantities].filter(([,quantity])=>quantity>0).map(([id,quantity])=>({id:Number(id),quantity,properties:{'Bundle':this.text('property',{count:tier.count}),'_lila_bundle':group}}));
      try{
        const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok){this.locked=true;this.status.textContent=(result.description||this.text('changed'))+' '+this.text('retry');this.querySelector('.lb-recovery').hidden=false;return;}
        this.locked=true;
        window.location.assign(this.dataset.root+'discount/'+encodeURIComponent(tier.code)+'?redirect='+encodeURIComponent(this.dataset.cart));
      }catch(error){
        this.locked=true;this.status.textContent=this.text('connection');this.querySelector('.lb-recovery').hidden=false;
      }finally{this.busy=false;this.render();}
    }
  });
}

